<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import { validRequired, validRangeDate } from '@/common/elementValid.js';
import { Post } from '@/backend/services/base/baseAjax.js';
import api from '@/backend/apiConfig/apiConfig';

let getServiceList = param => {
	return Post({
		url: api.service.getReportServiceList,
		bodyParam: param,
	});
};

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let { serviceId, time, defaultKey = '' } = attributes;
	return {
		customerId: {
			label: '选择客户',
			formType: 'customerSearch',
			value: '',
			controlButton: false,
			defaultKey,
			rules: [validRequired('请选择客户')],
			runDefaultKey(item) {
				vm.defaultKey = item.value;
			},
		},
		serviceId: {
			label: '选择CID',
			formType: 'sky-select',
			value: serviceId || '',
			options: [],
			props: {
				label: 'label',
				value: 'value',
			},
			customOption: true,
			setOptionValue: item => {
				let { serviceCode } = item;
				return serviceCode;
			},
			async onChange(self, field) {
				let { itemName, value: customerId } = field;
				if (itemName === 'customerId') {
					let { data } = await getServiceList({
						customerId,
					});
					self.formData.fields.serviceId.options = data.map(item => {
						let { googleCidAccountVal, id } = item;
						return {
							label: googleCidAccountVal,
							value: id,
							...item,
						};
					});
				}
			},
			rules: [validRequired('请选择CID')],
		},
		time: {
			label: '日期范围',
			formType: 'sky-date-picker',
			value: time || [],
			type: 'daterange',
			rangeSeparator: '至',
			startPlaceholder: '开始日期',
			endPlaceholder: '结束日期',
			rules: [
				{
					required: true,
					...validRangeDate('请选择日期范围'),
				},
			],
		},
	};
}

async function submit(data) {
	try {
		let { time } = data;
		let { defaultKey } = this;
		data.startDate = time[0];
		data.endDate = time[1];
		this.$emit('confirm', {
			defaultKey,
			...data,
		});
	} catch (error) {
		this.formData.loading = false;
	}
}

let watch = {
	'formData.loading': {
		handler(val) {
			let { attributes } = this;
			let { customerId } = attributes;
			if (!val && customerId) {
				this.formData.fields.customerId.value = customerId;
			}
		},
		deep: true,
	},
};

function cancel(self) {
	self.$emit('cancel');
}

async function onShowLoad(data) {
	return data;
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
		watch,
	},
	{
		labelPosition: 'top',
		labelWidth: '100px',
		subButton: '确定',
	}
);

export default formDialogCreate({
	name: 'reportPreview',
	onShowLoad,
	componentForm,
});
</script>

<style scoped lang="scss"></style>
